<template>
    <div style="width: 100%;margin: auto">
      搜索：<input type="text" v-model="searchKey" placeholder="请输入内容"/>
      <button v-if="isShow1" @click="saveEditor" style="background: #5a4f;color: white;height: 30px;border-radius: 4px;margin-left: 30px">保存修改</button>
      <table>
        <thead>
          <tr>
            <th v-for="item in thProp" >
              {{item.label}}
              <!--不同的列有不同的排序，需要一个保存列的排序对象setOrder-->
              <span v-if="item.sortable === true"  @click="sortBy(item.prop)" class="arrow" :class="setOrder[item.prop] > 0 ? 'asc':'dsc'"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in filterData" >
            <td v-for="(team) in thProp" v-if="item[team.prop]!==undefined" :style="{width:team.width + 'px'}" @click="edit(item,team.prop)">
              <input type="text" v-model="item[team.prop]"  style="border: 0;text-align: center"/>
              <button v-if="id === item.id && chooseProp === team.prop && isShow" @click.stop="confirmEdit(item,team.prop)">确认</button>
              <button v-if="id === item.id && chooseProp === team.prop && isShow" @click.stop="cancelEdit(item,team.prop)">取消</button>
            </td>
            <td>
              <slot v-bind:row="item" v-bind:index="index"/>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
</template>

<script>
    export default {
      props:{
        thProp:Array,
        data:Object,
        filterKey: String,// 搜索
      },
      data(){
        let colOrders = {};
        let prop = [];
        for(let i=0;i<this.thProp.length;i++){
          prop.push(this.thProp[i].prop);
        }
        prop.forEach(function (col) {
          colOrders[col] = 1;
        });
        return{
          isShow:false,
          isShow1:false,
          chooseProp:'',
          id:'',
          dataList:[],
          value:'',
          setOrder:colOrders,// 设置顺序
          sortKey: '',// 排序值
          searchKey:''//搜索值
        }
      },
      computed: {
        filterData: function() {
          let sortKey = this.sortKey;
          let data = this.data.list;
          let filterKey = this.searchKey && this.searchKey.toLowerCase();
          let order = this.setOrder[sortKey];
          if (filterKey) {
            data = data.filter(function(row) {
              return Object.keys(row).some(function(key) {
                return String(row[key]).toLowerCase().indexOf(filterKey) > -1
              })
            })
          }
          if (sortKey) {
            data.sort(function(a, b) {
              a = a[sortKey];
              b = b[sortKey];
              console.log(typeof (a));
              if(typeof(a)==='string'){
                a = a.replace(/[^0-9]/ig,'');
                b = b.replace(/[^0-9]/ig,'');
              }
              return  order > 0 ? a-b : b-a;
            })
          }
          return data
        }
      },
      methods:{
        edit(data,prop){
          this.id = data.id;
          this.chooseProp = prop;
          this.isShow = true;
          this.isShow1 = true;
          this.value = data[prop];
        },
        confirmEdit(data,prop){// 确认修改
          this.isShow = false;
          if(this.dataList.length === 0){
            this.dataList.push(data);
          }
          let ids = [];
          for(let i=0;i<this.dataList.length;i++){
            ids.push(this.dataList[i].id);
          }
          if(ids.indexOf(data.id)>-1){
            for(let i=0;i<this.dataList.length;i++){
              if(this.dataList[i].id === data.id){
                this.dataList[i][prop] = data[prop];
              }
            }
          }else {
            this.dataList.push(data);
          }
          console.log(this.dataList);
        },
        cancelEdit(data,prop){// 取消修改
          this.isShow = false;
          data[prop] = this.value;
        },
        saveEditor(){// 保存
          this.isShow1 = false;
          this.$emit('saveEdit',this.dataList);
        },
        sortBy(col){// 排序
          //对一个包含对象的数组的排序，需要提供一个对象键并以此值来进行排序
          this.sortKey = col;
          this.setOrder[col] = this.setOrder[col] * -1;
        },

        },
      mounted(){
        this.searchKey = this.filterKey;
      }
    }
</script>

<style scoped>
  table {
    border: 2px solid #42b983;
  }

  th {
    background: #42b983;
    padding: 10px 20px;
  }

  td {
    padding: 10px 20px;
    min-width: 120px;
    background: rgb(231, 226, 226);
    text-align: center;
  }

  input {
    margin-bottom: 7px;
    border: 1px solid #42b983;
    height: 2em;
    line-height: 2em;
    display: inline-block;
    padding: 0 3px;
  }

  .arrow {
    margin-left: 3px;
    vertical-align: middle;
    width: 0;
    height: 0;
    cursor: pointer;
  }

  .arrow.dsc {
    display: inline-block;
    border: 10px solid #ccc;
    border-bottom: 0;
    /*若不为0，改变箭头方向时，也会改变箭头的位置*/
    border-color: #5a37fa transparent transparent;
  }

  .arrow.asc {
    display: inline-block;
    border: 10px solid #ccc;
    border-top: 0;
    border-color: transparent transparent #5a37fa;
  }
</style>



// WEBPACK FOOTER //
// src/components/tab.vue